export const BudgetRoutes = {

    GetAll: "Budget/all",
    Get: "Budget",
    Save: "Budget/save",
    Remove: "Budget/remove"
}